/**
 * Client routes. Every screen the framework provides is reachable by URL — nothing
 * is only available behind a button.
 *
 * There is deliberately NO deploy screen here. Deploying is not a page on the
 * website: it lives on its own server, on its own port, served as a standalone page
 * only where DEPLOY_PASSWORD is set. Shipping it in the site bundle would put a
 * deploy form on the public site that merely says "disabled".
 */
export const SCREENS = {
  home: '#home',
  login: '#/login',
  profile: '#/profile',
  admin: '#/admin',
  /** THIS browser only. No server call, no session, always allowed. */
  flushLocal: '#/flush-all',
  /** The shared epoch — every visitor. Admin only. */
  flushServer: '#/flush-server',
  secretFlags: '#/secret-flags',
} as const;

export type Screen = (typeof SCREENS)[keyof typeof SCREENS];

/** Screens that take over the page, rather than scrolling to an anchor. */
export const isScreen = (hash: string): hash is Screen =>
  hash === SCREENS.login ||
  hash === SCREENS.profile ||
  hash === SCREENS.admin ||
  hash === SCREENS.flushLocal ||
  hash === SCREENS.flushServer ||
  hash === SCREENS.secretFlags;

export const goTo = (screen: string): void => { window.location.hash = screen; };
